particle-move-question-between-section-dialog{width:100%}
/*# sourceMappingURL=move-question-between-section-dialog.component-EZBHS6A6.css.map */
